export default __webpack_public_path__ + "static/prog21-flowers-cd8eb286024289a474eae60f9316bd2a.svg";